import { VideoUploadType } from '../../pages/Home/VideoUploadType'

export enum ImageSize {
  small = 'small',
  large = 'large',
}

export interface BuildImagesUrlParams {
  videoUpload?: VideoUploadType
  thumbnailUrlOverride?: string
  size?: ImageSize | 'best'
}

type ImageSizes = { [key in ImageSize]: number }

const sizes: ImageSizes = {
  [ImageSize.small]: 320,
  [ImageSize.large]: 1280
}

const defaultSize = 'best'

export default function buildImagesUrl(params: BuildImagesUrlParams): string {
  const thumbnailKey = params.thumbnailUrlOverride || (params.videoUpload && params.videoUpload.thumbnailKey)
  if (thumbnailKey) {
    // TODO use different width for responsive screens?
    // Also: https://github.com/articulate/images#how-do-i-support-retina-devices
    let width
    const size = params.size || defaultSize
    if (size === 'best') {
      width = window.innerWidth <= sizes.small ? sizes.small : sizes.large
    } else {
      width = sizes[params.size as ImageSize]
    }
    const options = `f:jpg,b:fff,s:cover,q:50,w:${width}`

    return `${process.env.IMAGES_URI}/${options}/${thumbnailKey}`
  }
}
